import styles from './style.module.scss';

export type CompanyTagPropsType = {
  year?: string;
  payedLevel?: 'STRONG' | 'PREMIUM';
  style?: React.CSSProperties;
};

export const CompanyTag = (props: CompanyTagPropsType) => {
  const { year, payedLevel, style } = props;
  return (
    <div
      className={`${styles.companyTag} ${
        payedLevel === 'STRONG' ? styles.companyTagStrong : ''
      }`}
      style={style}
    >
      <span className={styles.companyTagText}>{year}年</span>
    </div>
  );
};
